import { useQuery } from '@tanstack/react-query';
import { User } from 'src/admin/users/types';

export const useCompanyUsers = (companyId: string | null) => {
  const { data, isLoading, isError } = useQuery<User[]>({
    queryKey: ['admin', 'companies', companyId, 'users'],
    enabled: !!companyId,
  });

  return { users: data, isLoading, isError };
};
